/**
 * Formats SQL query with proper indentation and line breaks
 * @param {string} query - The SQL query to format
 * @returns {string} Formatted SQL query
 */
export const formatSqlQuery = (query) => {
  if (!query) return "";
  
  // Fix: Replace triple or more double quotes with a single pair
  let cleaned = query.replace(/"{3,}/g, '"');
  // Also replace any double double quotes with a single pair
  cleaned = cleaned.replace(/"{2,}/g, '"');
  
  // Basic SQL formatting
  let formatted = cleaned
    // Add line breaks after common SQL keywords
    .replace(
      /\b(SELECT|FROM|WHERE|GROUP BY|ORDER BY|HAVING|JOIN|LEFT JOIN|RIGHT JOIN|INNER JOIN|OUTER JOIN|UNION|INSERT|UPDATE|DELETE|CREATE|ALTER|DROP)\b/gi,
      "\n$1"
    )
    // Add line breaks before common SQL keywords
    .replace(
      /\b(AND|OR|IN|NOT IN|LIKE|NOT LIKE|IS NULL|IS NOT NULL|BETWEEN|EXISTS|NOT EXISTS)\b/gi,
      "\n$1"
    )
    // Add line breaks after commas
    .replace(/,/g, ",\n")
    // Add line breaks after opening parentheses
    .replace(/\(/g, "(\n")
    // Add line breaks before closing parentheses
    .replace(/\)/g, "\n)")
    // Clean up multiple line breaks
    .replace(/\n\s*\n/g, "\n")
    // Add proper indentation
    .split("\n")
    .map((line, index) => {
      const trimmed = line.trim();
      if (!trimmed) return "";
      // Determine indentation level
      let indent = 0;
      if (trimmed.startsWith(")")) indent = 0;
      else if (
        trimmed.match(
          /^(AND|OR|IN|NOT IN|LIKE|NOT LIKE|IS NULL|IS NOT NULL|BETWEEN|EXISTS|NOT EXISTS)/i
        )
      )
        indent = 2;
      else if (
        trimmed.match(
          /^(FROM|WHERE|GROUP BY|ORDER BY|HAVING|JOIN|LEFT JOIN|RIGHT JOIN|INNER JOIN|OUTER JOIN|UNION)/i
        )
      )
        indent = 0;
      else if (trimmed.startsWith(",")) indent = 2;
      else if (trimmed.startsWith("(")) indent = 0;
      else indent = 2;
      return "  ".repeat(indent) + trimmed;
    })
    .filter((line) => line !== "")
    .join("\n");
  return formatted;
};
